module.exports = __webpack_public_path__ + "media/images/books-c339ad5653f625dfe32a5fc24568fc85.png";